import React from 'react';

import clsx from 'clsx';
import { useSelector } from 'react-redux';

import { RootState } from 'actions';
import FormBody from 'components/FormBody';
import FormHeader from 'components/FormHeader';
import MailTo from 'components/MailTo';
import PhoneTo from 'components/PhoneTo';
import { ProgressBarStatus } from 'enums/ProgressBarStatus';

import styles from './AlreadySetUpWithCSM.module.scss';

const AlreadySetUpWithCSM = () => {
  const { csm } = useSelector((state: RootState) => state.contractorPortal);

  return (
    <>
      <FormHeader
        title="Based on your application, it appears you are already set up with HFS."
        percent={ProgressBarStatus.Failed}
      />
      <FormBody>
        <p className={styles.csm_header}>Your Contractor Success Manager is:</p>
        <div className={styles.contact_info_container}>
          <p className={clsx('body_text--large', styles.consultant_name)}>{csm?.name}</p>
          <div className={styles.contact_info_item}>
            <PhoneTo number={csm?.phone} linkClassName={clsx('input_label', styles.link)} iconClassName={styles.icon} />
          </div>
          <div className={styles.contact_info_item}>
            <MailTo email={csm?.email} linkClassName={clsx('input_label', styles.link)} iconClassName={styles.icon} />
          </div>
        </div>
        <p>Please reach out to them with any questions or needs.</p>
      </FormBody>
    </>
  );
};

export default AlreadySetUpWithCSM;
